import { useState } from "react";
import PetDetailsModal from "./PetDetailsModal";

const petsData = [
  {
    id: 1,
    name: "Buddy",
    type: "Dog",
    breed: "Golden Retriever",
    age: 3,
    size: "Large (Over 60 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "3-5 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Moderate noise fine",
    grooming: "Regular grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1552053831-71594a27632d?w=300&h=300&fit=crop",
  },
  {
    id: 2,
    name: "Luna",
    type: "Cat",
    breed: "Siamese",
    age: 2,
    size: "Small (Under 25 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["cats"],
    noise: "Occasional sounds OK",
    grooming: "Weekly brushing",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=300&h=300&fit=crop",
  },
  {
    id: 3,
    name: "Max",
    type: "Dog",
    breed: "German Shepherd",
    age: 4,
    size: "Large (Over 60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "More than 5 hours",
    goodWith: ["children", "dogs"],
    noise: "Moderate noise fine",
    grooming: "Weekly brushing",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1568393691622-c7ba131d63b4?w=300&h=300&fit=crop",
  },
  {
    id: 4,
    name: "Bella",
    type: "Dog",
    breed: "Yorkshire Terrier",
    age: 5,
    size: "Small (Under 25 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children"],
    noise: "Occasional sounds OK",
    grooming: "High maintenance is fine",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1583511655826-05700d52f4d9?w=300&h=300&fit=crop",
  },
  {
    id: 5,
    name: "Charlie",
    type: "Dog",
    breed: "Labrador",
    age: 1,
    size: "Large (Over 60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "More than 5 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Noise doesn't bother me",
    grooming: "Weekly brushing",
    training: "Needs training",
    image:
      "https://images.unsplash.com/photo-1600804340584-c7db2eacf0bf?w=300&h=300&fit=crop",
  },
  {
    id: 6,
    name: "Mittens",
    type: "Cat",
    breed: "Persian",
    age: 4,
    size: "Small (Under 25 lbs)",
    activityLevel: "Couch Potato",
    timeNeeded: "Less than 1 hour",
    goodWith: ["cats"],
    noise: "Silent is golden",
    grooming: "High maintenance is fine",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=300&h=300&fit=crop",
  },
  {
    id: 7,
    name: "Rocky",
    type: "Dog",
    breed: "Bulldog",
    age: 6,
    size: "Medium (25-60 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children"],
    noise: "Moderate noise fine",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=300&h=300&fit=crop",
  },
  {
    id: 8,
    name: "Sophie",
    type: "Cat",
    breed: "Maine Coon",
    age: 3,
    size: "Medium (25-60 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children", "cats", "dogs"],
    noise: "Occasional sounds OK",
    grooming: "Regular grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1606225457115-9b0de873c5db?w=300&h=300&fit=crop",
  },
  {
    id: 9,
    name: "Duke",
    type: "Dog",
    breed: "Great Dane",
    age: 2,
    size: "Large (Over 60 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "3-5 hours",
    goodWith: ["children", "dogs"],
    noise: "Moderate noise fine",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1585559700398-1385b3a8aeb6?w=300&h=300&fit=crop",
  },
  {
    id: 10,
    name: "Whiskers",
    type: "Cat",
    breed: "British Shorthair",
    age: 7,
    size: "Small (Under 25 lbs)",
    activityLevel: "Couch Potato",
    timeNeeded: "Less than 1 hour",
    goodWith: ["cats"],
    noise: "Silent is golden",
    grooming: "Weekly brushing",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=300&h=300&fit=crop",
  },
  {
    id: 11,
    name: "Milo",
    type: "Dog",
    breed: "Beagle",
    age: 4,
    size: "Medium (25-60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "3-5 hours",
    goodWith: ["children", "dogs"],
    noise: "Noise doesn't bother me",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1505628346881-b72b27e84530?w=300&h=300&fit=crop",
  },
  {
    id: 12,
    name: "Shadow",
    type: "Cat",
    breed: "Russian Blue",
    age: 1,
    size: "Small (Under 25 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["cats"],
    noise: "Occasional sounds OK",
    grooming: "Weekly brushing",
    training: "Needs training",
    image:
      "https://images.unsplash.com/photo-1548366086-7f1b76106622?w=300&h=300&fit=crop",
  },
  {
    id: 13,
    name: "Daisy",
    type: "Dog",
    breed: "Poodle",
    age: 3,
    size: "Medium (25-60 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Occasional sounds OK",
    grooming: "High maintenance is fine",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1598133894008-61f7fdb8cc3a?w=300&h=300&fit=crop",
  },
  {
    id: 14,
    name: "Tiger",
    type: "Cat",
    breed: "Bengal",
    age: 2,
    size: "Small (Under 25 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "3-5 hours",
    goodWith: [],
    noise: "Moderate noise fine",
    grooming: "Weekly brushing",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1545249390-6bdfa286032f?w=300&h=300&fit=crop",
  },
  {
    id: 15,
    name: "Bear",
    type: "Dog",
    breed: "Newfoundland",
    age: 5,
    size: "Large (Over 60 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Occasional sounds OK",
    grooming: "Regular grooming",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=300&h=300&fit=crop",
  },
  {
    id: 16,
    name: "Coco",
    type: "Dog",
    breed: "Chihuahua",
    age: 8,
    size: "Small (Under 25 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "Less than 1 hour",
    goodWith: [],
    noise: "Noise doesn't bother me",
    grooming: "Minimal grooming",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1625794084867-8ddd239946b1?w=300&h=300&fit=crop",
  },
  {
    id: 17,
    name: "Simba",
    type: "Cat",
    breed: "Orange Tabby",
    age: 4,
    size: "Small (Under 25 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["cats", "dogs"],
    noise: "Occasional sounds OK",
    grooming: "Weekly brushing",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1574144611937-0df059b5ef3e?w=300&h=300&fit=crop",
  },
  {
    id: 18,
    name: "Zeus",
    type: "Dog",
    breed: "Husky",
    age: 2,
    size: "Large (Over 60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "More than 5 hours",
    goodWith: ["dogs"],
    noise: "Noise doesn't bother me",
    grooming: "Regular grooming",
    training: "Needs training",
    image:
      "https://images.unsplash.com/photo-1605568427561-40dd23c2acea?w=300&h=300&fit=crop",
  },
  {
    id: 19,
    name: "Oreo",
    type: "Cat",
    breed: "Tuxedo Cat",
    age: 6,
    size: "Small (Under 25 lbs)",
    activityLevel: "Couch Potato",
    timeNeeded: "Less than 1 hour",
    goodWith: ["children", "cats"],
    noise: "Silent is golden",
    grooming: "Minimal grooming",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1606214174585-fe31582dc6ee?w=300&h=300&fit=crop",
  },
  {
    id: 20,
    name: "Nala",
    type: "Cat",
    breed: "Ragdoll",
    age: 2,
    size: "Medium (25-60 lbs)",
    activityLevel: "Couch Potato",
    timeNeeded: "Less than 1 hour",
    goodWith: ["children", "cats"],
    noise: "Silent is golden",
    grooming: "Regular grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1615789591457-74a63395c990?w=300&h=300&fit=crop",
  },
  {
    id: 21,
    name: "Buster",
    type: "Dog",
    breed: "Jack Russell Terrier",
    age: 7,
    size: "Small (Under 25 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "3-5 hours",
    goodWith: ["dogs"],
    noise: "Noise doesn't bother me",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1593134257782-e89567b7718a?w=300&h=300&fit=crop",
  },
  {
    id: 22,
    name: "Rosie",
    type: "Dog",
    breed: "Cavalier King Charles Spaniel",
    age: 4,
    size: "Small (Under 25 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "1-3 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Occasional sounds OK",
    grooming: "Regular grooming",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1612195583950-b8fd34c87093?w=300&h=300&fit=crop",
  },
  {
    id: 23,
    name: "Princess",
    type: "Cat",
    breed: "Himalayan",
    age: 3,
    size: "Small (Under 25 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "1-3 hours",
    goodWith: [],
    noise: "Silent is golden",
    grooming: "High maintenance is fine",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1570824104453-508955ab713e?w=300&h=300&fit=crop",
  },
  {
    id: 24,
    name: "Ginger",
    type: "Cat",
    breed: "Abyssinian",
    age: 2,
    size: "Small (Under 25 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "3-5 hours",
    goodWith: ["cats"],
    noise: "Moderate noise fine",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1536590158209-e9d615d525e4?w=300&h=300&fit=crop",
  },
  {
    id: 25,
    name: "Rex",
    type: "Dog",
    breed: "Rottweiler",
    age: 4,
    size: "Large (Over 60 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "3-5 hours",
    goodWith: ["children"],
    noise: "Moderate noise fine",
    grooming: "Minimal grooming",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1567752881298-894bb81f9379?w=300&h=300&fit=crop",
  },
  {
    id: 26,
    name: "Patches",
    type: "Cat",
    breed: "Calico",
    age: 7,
    size: "Small (Under 25 lbs)",
    activityLevel: "Not Very Active",
    timeNeeded: "Less than 1 hour",
    goodWith: ["children", "cats"],
    noise: "Silent is golden",
    grooming: "Weekly brushing",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1585373683920-671438c82bfa?w=300&h=300&fit=crop",
  },
  {
    id: 27,
    name: "Bruno",
    type: "Dog",
    breed: "Boxer",
    age: 3,
    size: "Large (Over 60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "More than 5 hours",
    goodWith: ["children", "dogs"],
    noise: "Noise doesn't bother me",
    grooming: "Minimal grooming",
    training: "Basic trained",
    image: "https://placedog.net/300/300?id=27",
  },
  {
    id: 28,
    name: "Snowball",
    type: "Cat",
    breed: "Turkish Angora",
    age: 5,
    size: "Small (Under 25 lbs)",
    activityLevel: "Moderately Active",
    timeNeeded: "1-3 hours",
    goodWith: ["cats"],
    noise: "Occasional sounds OK",
    grooming: "High maintenance is fine",
    training: "Well trained",
    image:
      "https://images.unsplash.com/photo-1596854407944-bf87f6fdd49e?w=300&h=300&fit=crop",
  },
  {
    id: 29,
    name: "Finn",
    type: "Dog",
    breed: "Irish Setter",
    age: 2,
    size: "Large (Over 60 lbs)",
    activityLevel: "Very Active",
    timeNeeded: "More than 5 hours",
    goodWith: ["children", "dogs", "cats"],
    noise: "Moderate noise fine",
    grooming: "Regular grooming",
    training: "Needs training",
    image:
      "https://images.unsplash.com/photo-1565708097881-bbf4ecf47cc1?w=300&h=300&fit=crop",
  },
  {
    id: 30,
    name: "Misty",
    type: "Cat",
    breed: "Scottish Fold",
    age: 3,
    size: "Small (Under 25 lbs)",
    activityLevel: "Couch Potato",
    timeNeeded: "Less than 1 hour",
    goodWith: ["children", "cats"],
    noise: "Silent is golden",
    grooming: "Weekly brushing",
    training: "Basic trained",
    image:
      "https://images.unsplash.com/photo-1571566882372-1598d88abd90?w=300&h=300&fit=crop",
  },
];

export default function ResultPage({
  quizAnswers,
  addToFavorites,
  removeFromFavorites,
  favoritePets,
}) {
  const calculateMatchScore = (pet, answers) => {
    let score = 0;

    // Question 0: Size (exact match from quiz to pet data)
    if (answers[0] === pet.size || answers[0] === "No Preference") {
      score += 15;
    }

    // Question 1: Activity Level (exact match)
    if (answers[1] === pet.activityLevel) {
      score += 15;
    }

    // Question 2: Time (exact match)
    if (answers[2] === pet.timeNeeded) {
      score += 15;
    }

    // Question 3: Living situation
    if (answers[3] === "Apartment" && pet.size === "Small (Under 25 lbs)") {
      score += 5;
    } else if (answers[3] === "House with yard" && pet.type === "Dog") {
      score += 5;
    } else if (answers[3] === "Farm/Large Property") {
      score += 5; // Good for any pet
    }

    // Question 4: Experience
    if (answers[4] === "First-time owner" && pet.training === "Well trained") {
      score += 10;
    } else if (
      answers[4] === "Some experience" &&
      pet.training === "Basic trained"
    ) {
      score += 10;
    } else if (
      answers[4] === "Very experienced" &&
      pet.training === "Needs training"
    ) {
      score += 10;
    }

    // Question 5: Children
    if (answers[5] !== "No children" && pet.goodWith.includes("children")) {
      score += 10;
    } else if (answers[5] === "No children") {
      score += 5; // Any pet works
    }

    // Question 6: Noise (exact match)
    if (answers[6] === pet.noise) {
      score += 10;
    }

    // Question 7: Grooming (exact match)
    if (answers[7] === pet.grooming) {
      score += 10;
    }

    // Question 8: Other pets
    if (answers[8] === "Have dogs" && pet.goodWith.includes("dogs")) {
      score += 5;
    } else if (answers[8] === "Have cats" && pet.goodWith.includes("cats")) {
      score += 5;
    } else if (answers[8] === "No other pets") {
      score += 5; // Any pet works
    }

    // Question 9: Training preference
    if (
      answers[9] === "Already trained only" &&
      pet.training === "Well trained"
    ) {
      score += 5;
    } else if (
      answers[9] === "Basic training OK" &&
      pet.training === "Basic trained"
    ) {
      score += 5;
    } else if (
      answers[9] === "Love training activities" &&
      pet.training === "Needs training"
    ) {
      score += 5;
    }

    // Questions 10 & 11 (Budget & Age) - we don't have this data in pets
    // You could add age matching:
    const petAgeCategory =
      pet.age <= 1
        ? "Puppy/Kitten"
        : pet.age <= 3
        ? "Young (1-3 years)"
        : pet.age <= 7
        ? "Adult (3-7 years)"
        : "Senior (7+ years)";
    if (answers[11] === petAgeCategory) {
      score += 5;
    }

    return score;
  };

  // Filter and sort pets based on match scores
  const matchedPets = petsData
    .map((pet) => ({
      ...pet,
      matchScore: calculateMatchScore(pet, quizAnswers),
    }))
    .filter((pet) => pet.matchScore >= 60) // Only show 60%+ matches
    .sort((a, b) => b.matchScore - a.matchScore); // Sort by highest match first

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPet, SetSelectedPet] = useState(null);

  const handleOpenModal = (pet) => {
    SetSelectedPet(pet);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    SetSelectedPet(null);
  };

  return (
    <div className="results-container">
      <h1 className="results-title">Your Perfect Matches!</h1>

      {matchedPets.map((pet, index) => {
        return (
          <div
            key={pet.id}
            className="pet-card"
            style={{ position: "relative", overflow: "hidden" }}
          >
            {" "}
            <img
              className="pet-image"
              src={pet.image}
              alt={`${pet.breed} named ${pet.name}`}
            />
            <h3 className="pet-name">{pet.name}</h3>
            <p className="pet-info">
              {pet.age} years old • {pet.breed}
            </p>
            <p className="match-percentage">{pet.matchScore}% Match!</p>{" "}
            <button
              onClick={() => handleOpenModal(pet)}
              className="learn-more-button"
            >
              Learn More
            </button>
            <button
              onClick={() => addToFavorites(pet)}
              className="card-favorite-button"
            >
              ❤️
            </button>
          </div>
        );
      })}
      {isModalOpen && selectedPet && (
        <PetDetailsModal
          pet={selectedPet}
          onClose={handleCloseModal}
          addToFavorites={addToFavorites}
          quizAnswers={quizAnswers}
          matchScore={selectedPet.matchScore} 
        />
      )}
    </div>
  );
}
